import { useEffect } from "react";
import { saveCurrentDraft } from "../../services/saveDraft";
import { SAVE_BEFORE_AUTO_GRANT_AT_SECONDS } from "./constants";

/**
 * Preemptive save 5s before the server-side auto-grant. Only fires when the
 * holder is locked AND someone is requesting access AND the countdown has
 * reached exactly 5s. The 5s buffer is deliberate: we need the save to commit
 * BEFORE the server transfers the lock, because after the transfer the
 * holder's session no longer owns the lock and `UpdateDraft`'s
 * `VerifyOwnership` check would return 409.
 *
 * This is what makes the AC's "page saves any changes" work both when the
 * holder explicitly clicks Give Access (saveCurrentDraft is awaited inside
 * the grant action handler) and when they let the timer run out.
 */
export function usePreemptiveSave(
  enabled: boolean,
  lockStatus: string,
  incomingRequest: unknown,
  countdownSeconds: number | null,
): void {
  useEffect(() => {
    if (!enabled) return;
    if (lockStatus !== "locked") return;
    if (!incomingRequest) return;
    if (countdownSeconds !== SAVE_BEFORE_AUTO_GRANT_AT_SECONDS) return;
    void saveCurrentDraft();
  }, [enabled, lockStatus, incomingRequest, countdownSeconds]);
}
